import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { agencyValidator } from 'features/agencies/validators/agency'

import { currencies } from '@albacross/frontend-utils'
import { EPlanName } from '@albacross/types'

import { FormSelect, FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'

type AgencyFormProps = {
  handleSubmit: (...args: any[]) => any
  open: boolean
  onClose: (...args: any[]) => any
  onSubmit: (...args: any[]) => any
}

const AgencyForm = ({ handleSubmit, open, onClose, onSubmit }: AgencyFormProps) => {
  const currencyOptions = [...currencies].map(([iso, currency]: any) => ({
    value: iso,
    label: currency.get('printableName'),
  }))

  return (
    <Dialog onClose={onClose} open={open}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Create Agency Plan</DialogTitle>

        <DialogContent>
          <Grid container spacing={2} style={{ width: 500 }}>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Price" name="price" type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormSelect allowEmpty={false} label="Currency" name="currency" options={currencyOptions} />
            </Grid>

            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Starter accounts" name={EPlanName.Starter} type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Pro accounts" name={EPlanName.Pro} type="number" />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: 500, marginTop: '40px' }}>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Premium accounts" name={EPlanName.Premium} type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Business accounts" name={EPlanName.Business} type="number" />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: 500, marginTop: '40px' }}>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Free accounts" name={EPlanName.Free} type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Free US accounts" name={EPlanName.FreeUS} type="number" />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: 500, marginTop: '40px' }}>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="AppSumo accounts" name={EPlanName.Appsumo} type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Enterprise accounts" name={EPlanName.Enterprise} type="number" />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: 500, marginTop: '40px' }}>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField label="Self service accounts" name={EPlanName.SelfService} type="number" />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}>
              <FormTextField
                helperText="Value -1 means unlimited sub-accounts"
                label="Agency accounts"
                name={EPlanName.Agency}
                type="number"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'customerAgency', validate: agencyValidator })(AgencyForm)
